import { render } from "./MessageTile.vue?vue&type=template&id=0b5d842d"
import script from "./MessageTile.vue?vue&type=script&lang=js"
export * from "./MessageTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__